const searchReducer = (state={}, action) => {
    switch (action.type){
        case 'SET_SEARCH':{
            let buttonFlag = action.buttonFlag
            let newState = {buttonFlag:buttonFlag}
            return state = newState;
        }
        default : return state
    }
}

export default searchReducer
